import { IOption } from "../models/IReduxFormHandlers";

export const sensorTypeOptions: IOption[] = [
  { id: -1, value: "--select--"},
  { id: 0, value: "IAQSensor" },
  // { id: 1, value: "OtherSensor" },
];